import React, { useEffect } from 'react';
import { RadioGroup } from 'src/core/forms';
import { RadioCard } from 'src/components/Common/RadioCards';
import { Price } from 'src/components/Helpers/Price';
import { useQty } from 'src/components/ProductDetail/ProductDetailContext';

import classes from './ProductDetailPricing.scss';

type Price = {
    price: number;
    price_incl: number;
    qty: number;
    discount: number;
};
interface Props {
    prices: Price[];
    title: string;
    setLocalVat: any;
    isPriceDisplayedAbove?: boolean;
}

export const ProductDetailPricing: React.FC<Props> = React.memo(({ prices, title, setLocalVat }) => {
    useEffect(() => {
        setLocalVat(false);
    }, [setLocalVat]);

    const qtySelected = useQty();
    const computedPrices = prices.find((price, index) => {
        const next = prices[index + 1];
        const nextQty = (next && next.qty) ?? Infinity;
        const isActive = qtySelected >= price.qty && qtySelected < nextQty;

        return isActive;
    });

    const priceSelectedWithVat = computedPrices ? computedPrices.price_incl : prices[0].price_incl;
    const priceSelectedWithoutVat = computedPrices ? computedPrices.price : prices[0].price;

    return (
        <div className={classes.container}>
            <h2 className={classes.title}>{title}</h2>
            <div className={classes.content}>
                <p className={classes.description}>
                    Personal purchases are VAT free but buying on behalf of a business incurs VAT (20%)
                </p>
                <div className={classes.radioGroupContainer}>
                    <RadioGroup initialValue="product_detail_pricing_1" field="product_detail_pricing">
                        <div className={classes.radioContainer}>
                            <RadioCard
                                onClick={() => setLocalVat(false)}
                                value="product_detail_pricing_1"
                                key={0}
                                id="product_detail_pricing_1"
                            >
                                <h2 className={`${classes.priceContainerTitle} priceContainerTitle`}>Personal</h2>
                                <h2
                                    className={`${classes.priceContainerTitle} priceContainerTitle priceContainerTitle__price`}
                                >
                                    <Price
                                        price={priceSelectedWithoutVat}
                                        priceIncl={priceSelectedWithVat}
                                        vat={false}
                                    />
                                </h2>
                            </RadioCard>
                        </div>
                        <div className={classes.radioContainer}>
                            <RadioCard
                                onClick={() => setLocalVat(true)}
                                value="product_detail_pricing_2"
                                key={1}
                                id="product_detail_pricing_2"
                            >
                                <h2 className={`${classes.priceContainerTitle} priceContainerTitle`}>Business</h2>
                                <div className={classes.priceContainerVat}>
                                    <h2
                                        className={`${classes.priceContainerTitle} priceContainerTitle priceContainerTitle__price`}
                                    >
                                        <Price
                                            price={priceSelectedWithoutVat}
                                            priceIncl={priceSelectedWithVat}
                                            vat={true}
                                        />
                                    </h2>
                                    <span className={classes.priceContainerVatInfo}>inc. VAT</span>
                                </div>
                            </RadioCard>
                        </div>
                    </RadioGroup>
                </div>
            </div>
        </div>
    );
});
